module.exports = __webpack_public_path__ + "images/cefbde7.jpg";